import 'css-chunksrc/client/scenes/task/details/nameForm/styles.scss';export default {
  "input": "_input_1abvl_1",
  "invalid": "_invalid_1abvl_16"
};